document.addEventListener('DOMContentLoaded', () => {
  const selectors = {
    stickyAtcBuyNow: '.sticky-atc__product-atc--buy-now',
    select: '.select',
    selectOptions: '.select__options',
    selectLabel: '.select__label',
    inputLabel: '.select__option',
    cardVariants: '.product-form__variant',
    addToCartForm: '.form',
    cartCount: '[data-minicart-open] [data-totalcount]',
    variantInput: '.product-variant-id',
    radioButtons: '.select__option',
    popup: '.popup-customize',
    popupImg: '.popup-content img',
    popupClose: '.close-popup',
    labelContent: '.select__label-content',
    customizationModule: '.customization-module',
    headerSection: '#shopify-section-header',
    templateV4: '.product-main-ds__container--v4',
    lightInput: '.select__label-content .input-lights',
    skinInput: '.select__label-content .input-skin',
    powerInput: '.select__label-content .input-power',
    accessoryInput: '.select__label-content .input-accessory',
    checkedLightInput: '[data-selector-type="light"] input:checked',
    checkedSkinInput: '[data-selector-type="skin"] input:checked',
    checkedPowerInput: '[data-selector-type="power"] input:checked',
    checkedAccessoryInput: '[data-selector-type="accessory"] input:checked',

    customizationActive: 'customization-module__button--active',
    popupActive: 'popup-active',
    selectActive: 'select--active',
    cardVariantsActive: 'product-form__variant--active',
    formWrap: '.product_form',
  };

  window.DS.globalSelect = () => {
    document.querySelectorAll(selectors.selectLabel).forEach((select) => {
      select.addEventListener('click', function () {
        this.closest(selectors.select).classList.toggle(selectors.selectActive);
        this.closest(selectors.select)
          .querySelectorAll('.option-info__image')
          .forEach((item) => {
            item.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              document.querySelector(selectors.popupImg).src = this.dataset.image;
              document
                .querySelector(selectors.popup)
                .classList.add(selectors.popupActive);
              document.querySelector('body').classList.add(selectors.popupActive);
            });
          });
        document
          .querySelector(selectors.popupClose)
          .addEventListener('click', () => {
            document
              .querySelector(selectors.popup)
              .classList.remove(selectors.popupActive);
            document.querySelector('body').classList.remove(selectors.popupActive);
            document.querySelector(selectors.popupImg).src = '';
          });
        this.closest(selectors.select).querySelectorAll(selectors.radioButtons).forEach((input) => {
          input.addEventListener('click', function () {
            const closestSelect = this.closest(selectors.select);
            this.closest(selectors.select).classList.remove(
              selectors.selectActive,
            );
            if (
              this.closest(selectors.select).querySelector(
                selectors.labelContent,
              )
            ) {
              this.closest(selectors.select).querySelector(
                selectors.labelContent,
              ).innerHTML = this.closest(selectors.select)
                .querySelector('input:checked')
                .closest(selectors.inputLabel)
                .querySelector('.option-info').innerHTML;

              this.closest(selectors.select)
                .querySelector(selectors.selectLabel)
                .classList.add('selected');
              document.querySelector(
                `.customization-module__button[data-selector-type=${this.closest(selectors.select).dataset.selectorType}] span`,
              ).innerText = 'Remove';
              document.querySelector(
                `.customization-module__button[data-selector-type=${this.closest(selectors.select).dataset.selectorType}]`,
              ).classList.add(selectors.customizationActive);
            } else {
              closestSelect.querySelector(selectors.selectLabel).innerText = closestSelect
                .querySelector('input:checked')
                .closest(selectors.inputLabel)
                .querySelector('span').innerText;
              let variant = '';
              this.closest(selectors.addToCartForm)
                .querySelectorAll('input:checked')
                .forEach((item) => {
                  variant
                    += `${item.closest(selectors.inputLabel).querySelector('span')
                      .innerText} / `;
                });

              variant = variant.slice(0, -3);
              const variants = this.closest(
                selectors.cardVariants,
              ).dataset.variants.split(';');

              variants.forEach((item) => {
                if (item.includes(variant)) {
                  this.closest(selectors.addToCartForm).querySelector(
                    selectors.variantInput,
                  ).value = item.split(':')[1];
                }
              });
            }
            const customizationModule = document.querySelector(selectors.customizationModule);
            const headerSection = document.querySelector(selectors.headerSection);
            customizationModule && window.scrollTo({
              top: customizationModule?.offsetTop - headerSection?.offsetHeight,
              behavior: 'smooth',
            });
          });
        });
      });
    });

    function updateCartItemCounts(count) {
      document.querySelectorAll(selectors.cartCount).forEach((el) => {
        el.textContent = count;
      });
    }

    document.querySelectorAll('.swatch').forEach((item) => {
      if (item.querySelector('.swatch-element.available') && !window.location.href.includes('variant=')) {
        item.querySelector('.swatch-element.available').previousElementSibling.checked = true;
        document.querySelector('.action_button span').innerHTML = 'Add To Cart';
        document.querySelector('.sold-out__container span').style.display = 'none';
      }
    });

    if (document.querySelector(selectors.templateV4)) {
      const buttonLightInner = document.querySelector('[data-selector-type="light"].customization-module__button')?.innerHTML;
      const buttonSkinInner = document.querySelector('[data-selector-type="skin"].customization-module__button')?.innerHTML;
      const buttonPowerInner = document.querySelector('[data-selector-type="power"].customization-module__button')?.innerHTML;
      const buttonAccessoryInner = document.querySelector('[data-selector-type="accessory"].customization-module__button')?.innerHTML;

      document.addEventListener('click', (e) => {
        if (e.target.closest('.select__option')) {
          const select = e.target.closest('.select').dataset.selectorType;
          const currentButton = document.querySelector(`[data-selector-type="${select}"].customization-module__button`);

          if (e.target.closest('.select__option').classList.contains('none-selected')) {
            if (currentButton.dataset.selectorType == 'light') {
              currentButton.innerHTML = buttonLightInner;
            } else if (currentButton.dataset.selectorType == 'skin') {
              currentButton.innerHTML = buttonSkinInner;
            } else if (currentButton.dataset.selectorType == 'power') {
              currentButton.innerHTML = buttonPowerInner;
            } else if (currentButton.dataset.selectorType == 'accessory') {
              currentButton.innerHTML = buttonAccessoryInner;
            }
          } else {
            currentButton.querySelector('span').innerHTML = `${e.target.closest('.select__option').querySelector('.input-value').innerHTML.slice(0, 8)}...`;

            if (e.target.closest('.select__option').querySelector('.option-info__image img')?.src) {
              const img = e.target.closest('.select__option').querySelector('.option-info__image img').src;
              currentButton.querySelectorAll('.img_wrapper').forEach((item) => {
                item.classList.add('full-img');
              });
              currentButton.querySelectorAll('.img_wrapper picture source').forEach((item) => {
                item.srcset = img;
              });
            }
          }
        }
      });
    }

    async function addToCart(form, buyNow = false, event) {
      event.preventDefault();
      if (
        form.querySelector(selectors.cardVariants)
        && !form
          .querySelector(selectors.cardVariants)
          .classList.contains(selectors.cardVariantsActive)
      ) {
        form
          .querySelector(selectors.cardVariants)
          .classList.add(selectors.cardVariantsActive);
      } else {
        const { href: fullUrl } = window.location;
        const href = fullUrl.split('#')[0];
        const prodVariant = href.split('variant=')[1]
          ? href.split('variant=')[1]
          : form.querySelector(selectors.variantInput).value;
        const formData = {
          items: [
            {
              id: +prodVariant,
              quantity: 1,
            },
          ],
        };

        if (document.querySelector(selectors.templateV4)) {
          const checkedLightInput = document.querySelector(selectors.checkedLightInput);
          const checkedSkinInput = document.querySelector(selectors.checkedSkinInput);
          const checkedPowerInput = document.querySelector(selectors.checkedPowerInput);
          const checkedAccessoryInput = document.querySelector(selectors.checkedAccessoryInput);

          if (checkedLightInput?.dataset.productId) {
            const customizedSkins = {
              id: +checkedLightInput?.dataset.productId,
              quantity: 1,
            };

            formData.items.push(customizedSkins);
          }

          if (checkedPowerInput?.dataset.productId) {
            const customizedPower = {
              id: +checkedPowerInput?.dataset.productId,
              quantity: 1,
            };

            formData.items.push(customizedPower);
          }

          if (checkedAccessoryInput?.dataset.productId) {
            const customizedAccessory = {
              id: +checkedAccessoryInput?.dataset.productId,
              quantity: 1,
            };

            formData.items.push(customizedAccessory);
          }

          if (checkedSkinInput?.dataset.productId) {
            const customizedLights = {
              id: +checkedSkinInput?.dataset.productId,
              quantity: 1,
            };

            formData.items.push(customizedLights);
          }
        } else {
          const lightInput = document.querySelector(selectors.lightInput);
          const skinInput = document.querySelector(selectors.skinInput);
          const powerInput = document.querySelector(selectors.powerInput);
          const accessoryInput = document.querySelector(selectors.accessoryInput);

          if (lightInput) {
            const customizedSkins = {
              id: +lightInput.dataset.productId,
              quantity: 1,
            };

            formData.items.push(customizedSkins);
          }

          if (powerInput) {
            const customizedPower = {
              id: +powerInput.dataset.productId,
              quantity: 1,
            };

            formData.items.push(customizedPower);
          }

          if (accessoryInput) {
            const customizedAccessory = {
              id: +accessoryInput.dataset.productId,
              quantity: 1,
            };

            formData.items.push(customizedAccessory);
          }

          if (skinInput) {
            const customizedLights = {
              id: +skinInput.dataset.productId,
              quantity: 1,
            };

            formData.items.push(customizedLights);
          }
        }

        document.querySelectorAll('.customization-module__button-product.button-active').forEach((product) => {
          const customizedProduct = {
            id: +product.dataset.productId,
            quantity: 1,
          };

          formData.items.push(customizedProduct);
        });

        const formWrap = document.querySelector(selectors.formWrap).dataset;

        if (formWrap.currentProductType === formWrap.productGiftType && formWrap.giftProduct !== '') {
          let skipGift = false;
          const result = await fetch('/cart.js');

          if (result.ok) {
            const cart = await result.json();
            cart.items.forEach((item) => {
              if (item.product_type === formWrap.productGiftType) {
                cart.items.forEach((itemGift) => {
                  if (itemGift.id === +formWrap.giftProduct) {
                    skipGift = true;
                  }
                });
              }
            });
          }

          if (!skipGift) {
            const giftProduct = {
              id: +formWrap.giftProduct,
              quantity: 1,
            };
            formData.items.push(giftProduct);
          }
        }

        await fetch('/cart/add', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then(() => {
            if (buyNow) {
              window.location.href = '/checkout';
            } else {
              window.Rebuy.SmartCart.show();
              window.Rebuy.Cart.fetchCart();
            }
          });
        const res = await fetch('/cart.js');
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
      }
    }

    if (document.querySelector(selectors.stickyAtcBuyNow)) {
      document.querySelector(selectors.stickyAtcBuyNow).addEventListener('click', (e) => {
        document.querySelectorAll(selectors.addToCartForm).forEach((form) => {
          addToCart(form, true, e);
        });
      });
    }

    document.querySelectorAll(selectors.addToCartForm).forEach((form) => {
      form.addEventListener('submit', (e) => {
        addToCart(form, false, e);
      });
    });
  };

  window.DS.globalSelect();
});
